/**
 * Topic photos: one per topic (Brian's Artlist renders, Oct 21 2026), hosted
 * with the app rather than on Artlist's image host. Brian's prototype uses short
 * ids (realestate); ours are the taxonomy ids (real-estate-market).
 *
 * If a photo fails to load, callers fall back to the topic's drawn scene.
 */
const IDS = new Set([
  'real-estate-market', 'new-business-openings', 'civic-government', 'events', 'food-drink', 'safety-alerts',
  'schools', 'development-construction', 'roads-transit', 'jobs-hiring', 'home-garden', 'outdoor-recreation',
  'tourism-destination', 'snow-weather', 'local-sports', 'arts-culture', 'agriculture-farming', 'nonprofits-causes',
  'health-wellness', 'politics', 'geopolitics', 'military', 'finance', 'technology', 'space', 'celebrity-news',
  'reality-tv', 'true-crime', 'cars', 'history-heritage', 'artists-bands', 'pro-sports', 'fitness', 'aviation',
])

/** Brian's short topic ids, for reading his specs and data. */
export const BRIAN_TOPIC_IDS: Record<string, string> = {
  realestate: 'real-estate-market', newbusiness: 'new-business-openings', civic: 'civic-government', events: 'events',
  food: 'food-drink', safety: 'safety-alerts', schools: 'schools', development: 'development-construction',
  roads: 'roads-transit', jobs: 'jobs-hiring', homegarden: 'home-garden', outdoor: 'outdoor-recreation',
  tourism: 'tourism-destination', weather: 'snow-weather', localsports: 'local-sports', arts: 'arts-culture',
  agriculture: 'agriculture-farming', nonprofits: 'nonprofits-causes', health: 'health-wellness', politics: 'politics',
  geopolitics: 'geopolitics', military: 'military', finance: 'finance', technology: 'technology', space: 'space',
  celebritynews: 'celebrity-news', realitytv: 'reality-tv', truecrime: 'true-crime', cars: 'cars',
  history: 'history-heritage', artistsbands: 'artists-bands', prosports: 'pro-sports', fitness: 'fitness',
  aviation: 'aviation',
}

/** The topic's photo URL, or null when there is none. */
export function topicPhoto(topic: string | null | undefined): string | null {
  if (!topic) return null
  const id = IDS.has(topic) ? topic : BRIAN_TOPIC_IDS[topic]
  return id ? `/topics/${id}.jpg` : null
}
